export default __webpack_public_path__ + "static/media/sanmar2.ecf6a449.jpg";